import { setLocalePath } from "@/locales/index";
export const locale_file_path = "views.user_permission_setting_dialog.";
/**
 * 언어팩 경로 셋팅 메서드
 * @param appendPath 추가로 붙일 경로 문자열
 * @returns
 */
export const initAutoLc = (appendPath = "") => setLocalePath(locale_file_path + appendPath);
export default {
    header: {
        title: "사용자 권한 설정",
    },
    controller: {
        user_name: "사용자명",
        user_level: "사용자레벨",
        copy_form: "권한 복사",
        paste_form: "권한 적용",
        copied_user_id: "복사 된 아이디",
        submit: "저장",
    },
    table_header: {
        category: "카테고리",
        permission_name: "권한명",
        permission_code: "권한코드",
        use_yn: "사용유무",
        hint: "설명",
    },
    confirm_cancel_title: "사용자 권한 설정 취소",
    confirm_cancel_message: "취소하시면 입력하신 정보가 저장되지 않습니다.\n그만하시겠습니까?",
    apply_success: "사용자 권한 설정이 완료되었습니다.",
    copy_success: "사용자 권한을 복사했습니다.",
    paste_success: "복사 된 사용자 권한을 적용했습니다.",
};
